import { useIntl } from 'react-intl';
import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { schemaExtender } from '../CustomObjectWidget/CustomObjectWidget';

export interface CustomObjectListWidgetProps {
  value?: Array<object>;
  default?: Array<object>;
  schema: object;
  /** Item field whose value labels the accordion tab (forwarded to ObjectListWidget) */
  itemTitleField?: string;
  /** `@id`s of items that must not be deleted (forwarded to ObjectListWidget) */
  fixedItemIds?: string[];
  onChange: (id: string, value: Array<object>) => void;
}

const CustomObjectListWidget: React.FC<CustomObjectListWidgetProps> = (
  props,
) => {
  const { value, default: defaultValue, schema, onChange, ...rest } = props;
  const intl = useIntl();

  return (
    <div className="custom-object-list-widget">
      {schema && (
        <ObjectListWidget
          schema={schema}
          schemaExtender={(
            schema: object & {
              properties: any;
              conditions?: any;
              omit?: any;
              fieldsets: any;
            },
            data: any,
          ) => schemaExtender(schema, data, intl)}
          {...rest}
          value={value || defaultValue || []}
          onChange={(id: string, value: Array<object>) => onChange(id, value)}
        />
      )}
    </div>
  );
};

export default CustomObjectListWidget;
